import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <h3>This website was designed by Zakari Nazim SAIBI</h3>
    </div>
  );
}

export default Footer;
